import React from 'react';
import { Wrapper } from 'AppReact';
import styled from 'styled-components';
import device from 'utils/device'

const template = styled.div`
    display: flex; 
    flex-direction: column;
    gap: 10px;

    @media ${device.tablet} {
        display: flex; 
        flex-direction: row;
        gap: 30px;
      }
    
    `

export const FieldWrapper = Wrapper(template);
